import { defineStore } from 'pinia'

export const useSubscriptionStore = defineStore('SubscriptionStore', {
    state: () => ({
        subscription: null,
        currentPlan: null,
        plans: [],
        accessibleModules: [],
        billingEnabled: false,
        loading: false,
    }),
    getters: {
        isSubscribed: (state) => {
            return state.subscription !== null && state.subscription?.active === true
        },
        hasIncompletePayment: (state) => {
            if (!state.subscription) return false
            return ['past_due', 'incomplete'].includes(state.subscription.stripe_status)
        },
        getCurrentPlan: (state) => {
            return state.currentPlan
        },
        hasModuleAccess: (state) => {
            return (moduleSlug) => {
                // If billing is disabled, all modules are accessible
                if (!state.billingEnabled) {
                    return true
                }
                return state.accessibleModules.includes(moduleSlug)
            }
        },
        getPlans: (state) => {
            return state.plans
        },
        getActivePlans: (state) => {
            return state.plans.filter(plan => plan.data.is_active)
        },
    },
    actions: {
        async fetchSubscription() {
            this.loading = true
            try {
                const response = await axios.get('/api/subscription')
                this.subscription = response.data.subscription
                this.currentPlan = response.data.plan?.data ?? null
            } catch (error) {
                console.error('Unable to fetch subscription:', error)
                this.subscription = null
                this.currentPlan = null
            } finally {
                this.loading = false
            }
        },
        async fetchPlans() {
            try {
                const response = await axios.get('/api/plans')
                this.plans = response.data.data
            } catch (error) {
                console.error('Unable to fetch plans:', error)
                this.plans = []
            }
        },
        async fetchAccessibleModules() {
            this.loading = true
            try {
                const response = await axios.get('/api/modules/accessible')
                this.accessibleModules = response.data.modules
                this.billingEnabled = response.data.billing_enabled
            } catch (error) {
                console.error('Unable to fetch accessible modules:', error)
                this.accessibleModules = []
            } finally {
                this.loading = false
            }
        },
    },
    persist: true,
})
